import MetricBase from "models/metrics/MetricBase";
import EmptyUnit from "models/metrics/unit/EmptyUnit";
import i18n from "i18next";
import ConnectivityGroup from "../../../../groups/ConnectivityGroup";

class MetricNoAvailabilityCount extends MetricBase {
    constructor() {
        super({
            field: "metric_noAvailabilityCount",
            defaultVisibility: true,
            unit: new EmptyUnit(),
            chartName: i18n.t("metrics.google_hotel_ads.noAvailabilityCount.chartName"),
            serieLabel: i18n.t("metrics.google_hotel_ads.noAvailabilityCount.serieLabel"),
            tooltip: i18n.t("metrics.google_hotel_ads.noAvailabilityCount.tooltip"),
            group: new ConnectivityGroup(),
        });
    }
}

export default MetricNoAvailabilityCount;
